export interface Notice {
  id: string;
  title: string;
  category: string;
  date: string;
  author: string;
  pinned: boolean;
  content: string;
}

export const notices: Notice[] = [
  {
    id: "busan-showroom-open",
    title: "부산 전시장 그랜드 오픈 안내",
    category: "공지",
    date: "2026.09.02",
    author: "동우스톤",
    pinned: true,
    content:
      "안녕하세요, 동우스톤입니다.\n\n부산 해운대에서 동우스톤의 새로운 전시장을 오픈합니다. 다양한 포세린, 대리석, 엔지니어드 스톤을 직접 눈으로 보고 손으로 만져보며 비교하실 수 있는 공간입니다.\n\n전시장에서는 실제 주방 상판과 욕실 시공 사례를 그대로 재현한 목업을 만나보실 수 있으며, 담당 디자이너가 소재 상담과 견적 안내를 도와드립니다. 오픈 기간에는 방문 고객을 대상으로 소재 샘플 키트를 제공해 드립니다.\n\n- 오픈일: 2026년 9월 20일 (토)\n- 운영시간: 평일 09:30 ~ 18:00 / 토요일 10:00 ~ 15:00\n- 주소: 부산광역시 해운대구 달맞이길 120-30, 5층\n- 상담 예약: 051-741-2045\n\n많은 관심과 방문 부탁드립니다.",
  },
  {
    id: "chuseok-schedule",
    title: "추석 연휴 배송 및 상담 일정 안내",
    category: "공지",
    date: "2026.08.28",
    author: "동우스톤",
    pinned: true,
    content:
      "안녕하세요, 동우스톤입니다.\n\n추석 연휴 기간의 배송 및 상담 일정을 아래와 같이 안내드립니다.\n\n- 휴무 기간: 2026년 9월 24일 (목) ~ 9월 27일 (일)\n- 배송 마감: 9월 21일 (월) 오후 2시까지 접수건에 한해 연휴 전 출고\n- 상담: 휴무 기간 중 홈페이지 문의 접수는 가능하며, 9월 28일부터 순차적으로 답변드립니다.\n\n연휴 기간 동안 시공 일정에 차질이 없도록 미리 주문과 상담을 진행해 주시기 바랍니다. 감사합니다.",
  },
  {
    id: "new-engineered-collection",
    title: "신제품 엔지니어드 스톤 컬렉션 출시",
    category: "신제품",
    date: "2026.08.12",
    author: "제품기획팀",
    pinned: false,
    content:
      "동우스톤이 2026년 신제품 엔지니어드 스톤 컬렉션을 선보입니다.\n\n이번 컬렉션은 천연석의 무늬를 더 정교하게 재현하면서도 흡수율을 낮춰 관리 부담을 줄인 것이 특징입니다. 주방 상판과 욕실 상판에 최적화된 12종의 신규 색상을 만나보실 수 있습니다.\n\n모든 제품은 대형 판재로 생산되어 이음새를 최소화할 수 있으며, 식품 접촉에 안전한 소재를 사용했습니다. 전시장에서 샘플을 직접 확인하신 후 상담받으실 수 있습니다.",
  },
  {
    id: "koreabuild-2026",
    title: "2026 코리아빌드 전시 참가 안내",
    category: "전시회",
    date: "2026.07.30",
    author: "마케팅팀",
    pinned: false,
    content:
      "동우스톤이 2026 코리아빌드 전시회에 참가합니다.\n\n이번 전시에서는 신제품 엔지니어드 스톤 컬렉션과 함께 실제 시공 사례를 담은 대형 목업을 전시합니다. 건축·인테리어 관계자뿐 아니라 소재에 관심 있는 일반 방문객도 자유롭게 관람하실 수 있습니다.\n\n- 기간: 2026년 8월 20일 (목) ~ 8월 23일 (일)\n- 장소: 서울 코엑스 Hall B, 부스 B-42\n- 입장: 사전 등록 시 무료\n\n부스에서 상담을 원하시는 분은 홈페이지 문의를 통해 사전 예약해 주시면 전담 담당자가 안내해 드립니다.",
  },
  {
    id: "privacy-policy-update",
    title: "개인정보 처리방침 개정 안내",
    category: "공지",
    date: "2026.07.05",
    author: "동우스톤",
    pinned: false,
    content:
      "안녕하세요, 동우스톤입니다.\n\n개인정보 보호법 개정에 따라 개인정보 처리방침이 아래와 같이 변경됩니다.\n\n- 변경 내용: 개인정보 수집 항목 및 보유 기간 명확화, 문의 접수 시 수집 항목 안내 구체화\n- 시행일: 2026년 7월 20일\n\n변경된 방침은 시행일부터 적용되며, 주요 내용을 확인하신 후 서비스 이용에 참고해 주시기 바랍니다. 문의 사항이 있으시면 고객문의 페이지를 통해 남겨 주시기 바랍니다.",
  },
  {
    id: "partner-recruitment",
    title: "하반기 시공 협력사 모집 공고",
    category: "채용",
    date: "2026.06.18",
    author: "경영지원팀",
    pinned: false,
    content:
      "동우스톤과 함께 성장할 시공 협력사를 모집합니다.\n\n모집 분야는 석재 시공 및 마감이며, 관련 경력 3년 이상의 업체를 대상으로 합니다. 선정된 협력사에는 안정적인 물량 배정과 기술 교육, 자재 우선 공급 등의 지원을 제공합니다.\n\n- 접수 기간: 2026년 6월 18일 ~ 7월 15일\n- 제출 서류: 사업자등록증 사본, 시공 실적 자료\n- 접수 방법: 고객문의 페이지로 문의 접수 후 담당자 안내\n\n많은 관심 부탁드립니다.",
  },
  {
    id: "website-renewal",
    title: "홈페이지 리뉴얼 오픈 안내",
    category: "공지",
    date: "2026.06.01",
    author: "동우스톤",
    pinned: false,
    content:
      "안녕하세요, 동우스톤입니다.\n\n고객 여러분께 더 편리한 정보를 제공하기 위해 홈페이지를 새롭게 단장했습니다.\n\n새 홈페이지에서는 제품 카테고리별 탐색과 시공 사례 갤러리를 한눈에 보실 수 있도록 구성했으며, 모바일에서도 빠르게 확인하실 수 있도록 최적화했습니다. 고객문의 접수도 더 간편해졌습니다.\n\n앞으로도 더 나은 서비스로 찾아뵙겠습니다. 감사합니다.",
  },
];